import { createSlice } from "@reduxjs/toolkit";
import {
  downLoadUcrtReportDatewise,
  fetchUcrtList,
  createUpdateUcrt,
  downLoadUcrtReport,fetchUcrtAuditTrailList,
  downLoadUcrtReportInCSVDatewise
} from "../actions/ucrtsAction";

export const ucrts = createSlice({
  name: "ucrts",
  initialState: {
    auditTrails: null,
    returnList:null,
    data: null,
    ucrts: null,
    filePath: null,
    updatedAt: null,
    downloadFileOfCurrentDate: null,
    downloadFileOfDate: null,
      downloadCsvFileOfDate: null,
    emailReport: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isDownloadLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded: false,
    isManageWardPage: false,
  },
  reducers: {
    userReset: (state) => {
      // state.ucrts= null;
      state.error = null;
    },
    resetPopup: (state) => {
      state.isLoader = false;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.error = null;
    },
    setManageWardPage: (state) => {
      state.isManageWardPage = true;
    },
    resetManageWardPage: (state) => {
      state.isManageWardPage = false;
    },
  },
  extraReducers: {
    [fetchUcrtList.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [fetchUcrtList.fulfilled]: (state, { payload }) => {
      state.error=null;
      return {
        ...state,
        ...payload?.data,
        isLoader: false
      }
    },
    [fetchUcrtList.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },

    [fetchUcrtAuditTrailList.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [fetchUcrtAuditTrailList.fulfilled]: (state, { payload }) => {
      state.error = null;
      return {
        ...state,
        ...payload?.data,
        isLoader: false,
      };
    },
    [fetchUcrtAuditTrailList.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },

    [createUpdateUcrt.pending]: (state, payload) => {
      state.error = null;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.isLoader = true;
    },
    [createUpdateUcrt.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isRecordAdded = true;
      state.isRecordUpdated = true;
      state.isLoader = false;
    },
    [createUpdateUcrt.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.isLoader = false;
    },

    [downLoadUcrtReportDatewise.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [downLoadUcrtReportDatewise.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadFileOfDate = payload?.data?.filePath;
      console.log("state.downloadFileOfDate", state.downloadFileOfDate);
      state.isDownloadLoader = false;
    },
    [downLoadUcrtReportDatewise.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
      [downLoadUcrtReportInCSVDatewise.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [downLoadUcrtReportInCSVDatewise.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadCsvFileOfDate = payload?.data?.filePath;
      state.isDownloadLoader = false;
    },
    [downLoadUcrtReportInCSVDatewise.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    //
    [downLoadUcrtReport.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [downLoadUcrtReport.fulfilled]: (state, { payload }) => {
      state.error = null;
      console.log("payload", payload);
      state.downloadFile = payload?.data?.filePath;
      console.log("state.downloadFile", state.downloadFile);
      state.isDownloadLoader = false;
    },
    [downLoadUcrtReport.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  userReset,
  userSort,
  userSearch,
  resetPopup,
  setManageWardPage,
  resetManageWardPage,
} = ucrts.actions;

export default ucrts.reducer;
